import cx from "classnames";
import { connect } from "react-redux";
import styled from "styled-components";
import { useAppService } from "../../hooks/use-app-service";

function CommunityNavLinksComponent({
  // props
  sidebarMode = false, // used to show a list instead of flex
  // state
  links,
}) {
  const { analyticsService } = useAppService();

  const triggerLinkClickEvent = (linkUrl) => {
    analyticsService.track('quick-link-click-header', {
      linkUrl
    })
  }
  return (
    <CommunityNavLinksWrapper
      className={cx("CommunityNavLinks", {
        "flex mobile-hidden": !sidebarMode,
        "mobile-only pt-2": sidebarMode,
      })}>
      {links.map((link) => (
        <NavButton
          className={cx(
            "theme-text-default flex items-center justify-between hover:theme-bg-default rounded",
            {
              "px-4 py-2": !sidebarMode,
              "px-6 py-4": sidebarMode,
            }
          )}
          onClick={() => triggerLinkClickEvent(link.url)}
          key={link.id}
          target="_blank"
          href={link.url}
          rel="noopener noreferrer"
          title={link.label}>
          {link.label}
        </NavButton>
      ))}
    </CommunityNavLinksWrapper>
  );
}

const CommunityNavLinksWrapper = styled.div`
  align-items: center;
`;

const NavButton = styled.a`
  cursor: pointer;
`;

const stp = (state) => ({
  links: state.communityLinks.links,
});

const CommunityNavLinks = connect(stp)(CommunityNavLinksComponent);

export default CommunityNavLinks;
